import { Controller } from "@hotwired/stimulus"

// An admin table (.adm-sheet), out to the window's edges. When the table
// fits across, nothing scrolls inside it, so its header row sticks to the top
// of the window as the page scrolls; too wide for the window, it scrolls in a
// window-tall box of its own instead (is-wide), its header stuck to that.
export default class extends Controller {
  connect() {
    this.fit = this.fit.bind(this)
    this.observer = new ResizeObserver(this.fit)
    // The table too: it settles to its new width only after the box has.
    this.observer.observe(this.element)
    const table = this.element.querySelector("table")
    if (table) this.observer.observe(table)
    this.fit()
  }

  disconnect() {
    this.observer.disconnect()
  }

  fit() {
    const table = this.element.querySelector("table")
    if (table) this.element.classList.toggle("is-wide", table.scrollWidth > this.element.clientWidth + 1)
  }
}
